// Maps a Relay/GraphQL mutation error to the board's coarse 403/404 toast
// branches. The gateway throws GraphQLError with extensions.code 'FORBIDDEN'
// for missing permissions (TicketingResolverGuard) and a not-found message for
// a missing ticket. We inspect the message text because Util.CommitMutation
// surfaces the error as an Error instance, not the raw GraphQLError envelope.
export function isPermissionError(err: unknown): boolean {
	const msg = err instanceof Error ? err.message : String(err);
	return /forbidden|permission|not authori[sz]ed|no viewer/i.test(msg);
}

export function isNotFoundError(err: unknown): boolean {
	const msg = err instanceof Error ? err.message : String(err);
	return /not found|404|no such ticket/i.test(msg);
}
